module.exports = __webpack_public_path__ + "assets/img/Kitome-Blog.a8b06ad9.webp";